import { UserOutlined } from '@ant-design/icons'
import { Avatar, Upload } from 'antd'
import clsx from 'clsx'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { PureInput } from '../../../../../common/ui/pure-input/pure-input'
import { useUserStore } from '../../../../../entities/user/stores/user.store'
import { User } from '../../../../../entities/user/types/user.types'

interface UserModalProps {
  profileData: User | null
  // TODO fix
  onChange: any
}

export const UserModal = ({ profileData, onChange }: UserModalProps) => {
  const { t } = useTranslation()

  const user = useUserStore((state) => state.user)
  const updateAvatar = useUserStore((state) => state.updateAvatar)

  const [loading, setLoading] = useState(false)

  const beforeUpload = (file: File) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
      toast.error('Можно загружать только файлы JPG/PNG!')

      return Upload.LIST_IGNORE
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
      toast.error('Изображение должно быть меньше 2MB!')

      return Upload.LIST_IGNORE // Отменяет загрузку в Antd
    }

    return true
  }

  // Перехват стандартного AJAX-запроса Ant Design
  const handleCustomRequest = async (options: any) => {
    const { file } = options

    setLoading(true)
    try {
      // Передаем чистый файл в Zustand стор
      await updateAvatar(file as File)
      toast.success('Аватар успешно обновлен!')
    } catch (error: any) {
      // Пытаемся достать ошибку с бэкенда, иначе пишем дефолтный текст
      const errorMsg = error?.response?.data?.message || 'Не удалось обновить аватар.'
      toast.error(errorMsg)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div className="d-flex flex-column gap-2">
      <div className={clsx('w-100 d-flex justify-content-center')}>
        <Upload
          action="/api/v1/user/avatar/"
          beforeUpload={beforeUpload as any}
          className="cursor-pointer"
          customRequest={handleCustomRequest}
          name="avatar"
          showUploadList={false}
        >
          <Avatar
            icon={!user?.avatar && <UserOutlined />}
            size={80}
            src={user?.avatar}
          />
        </Upload>
      </div>
      <PureInput
        label={t('settings.user.fio')}
        onChange={(e) => onChange((prev: any) => ({ ...prev, fio: e.target.value }))}
        placeholder={t('settings.user.fio')}
        required={false}
        value={profileData?.fio}
      />
      <PureInput
        label={t('settings.user.email')}
        onChange={(e) => onChange((prev: any) => ({ ...prev, email: e.target.value }))}
        placeholder={t('settings.user.email')}
        required={false}
        value={profileData?.email}
      />
    </div>
  )
}
